module.exports = __webpack_public_path__ + "static/img/caFlag.dda129f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/caFlag.png
// module id = K0Xg
// module chunks = 55